import { BlacklistElementOrigin as ApiBlacklistElementOrigin } from "src/graphql/anti-fraud/__generated__/graphql";
import { BlacklistElementOrigin } from "src/types/blacklist";

const ORIGIN_MAP: { [key in ApiBlacklistElementOrigin]: BlacklistElementOrigin } = {
  MANUAL: "manual",
  CASE_IDENTIFIER: "caseIdentifier",
  IMPORT: "import",
};

export const mapToBlacklistElementOrigin = (
  origin: ApiBlacklistElementOrigin
): BlacklistElementOrigin => {
  return ORIGIN_MAP[origin];
};
